export default {
  equal: '=',
  greater: '>',
  less: '<',
};
